import React from 'react';
import { Link } from 'react-router-dom';
import * as R from 'ramda';
import { CommonServices } from '../../../../../constants/utils/connectionTypes';


export const DemarchesCommunes = ({userId, setSubStep, setSelectedUserConnection, selectedUserConnection}) => {
  return (
      <article className="view-calc pt-0 mb-auto">
        <div className="container-fluid">
            <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 alert alert-primary text-center py-2">
                <h1 className="text-primary font-weight-bolder mt-2 mb-2">Démarches communes</h1>                    
            </header>
        </div>
        <div className="auto-view py-4 py-lg-0 mt-lg-sm">
            <div className="container-fluid">
                <section className="block">
                    <h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-0 mb-1">Démarches déjà comprises dans le service : </h4>
                    <p className="small o-50">Déselectionnez les démarches que le défunt n'a pas.</p>
                    <form className="pb-sm">
                        <div className="grid grid-sm-min grid-lg-tight grid-xl-single g-spacer">
                            {R.sortWith([R.ascend(R.prop('title'))])(Object.values(CommonServices)).map((srv, index) => {
                                return (
                                <div key={index + srv.title} className="form-group col col-lg-3 col-xl-2">
                                    <div className={"card p-2 text-center picker-card" + (selectedUserConnection.includes(srv.connectionType) ? " active" : "")} onClick={() => {
                                        if(!selectedUserConnection.includes(srv.connectionType)){
                                        setSelectedUserConnection([...selectedUserConnection, srv.connectionType]);
                                        }else{
                                        setSelectedUserConnection(selectedUserConnection.filter(s => s != srv.connectionType));
                                        }
                                        }}>
                                        <img className="img-fluid mx-auto mb-1 h-6 py-1 mt-sm mb-3" src={srv.icon} alt={srv.title} />
                                        <h2 className="h6 text-uppercase font-weight-bolder my-auto">{srv.title}</h2>
                                        {
                                            !R.isNil(srv.desc) && srv.desc !== "" ?
                                                <p className="small o-50 mt-0 mb-auto lh-copy h-6">{srv.desc.map((d, ind) => { return <React.Fragment key={ind}>{d}{ind !== (srv.desc.length - 1) ? <br /> : ''}</React.Fragment> })}</p>
                                            :
                                                ''
                                        }
                                        
                                    </div>
                                </div>
                                );
                            })}
                        </div>
                    </form>
                </section>
            </div>
        </div>        
        <div className="container-fluid">
                <footer className="flex-md-row align-items-center mt-auto mb-sm text-lg-right w-100">
                    <Link to={`/facilita/${userId}/onboarding/step1`} className="btn btn-faded px-md-gutter mr-3 ml-auto">Retour</Link>
                    <button className="btn btn-info px-md-gutter px-4" onClick={() => { setSubStep(2) }}>Passer à l'étape suivante</button>
                    <h6 className="my-3 my-md-0 mr-auto order-lg-first fs-3 o-60">* champs obligatoires</h6>
                </footer>
            </div>
      </article>
  )
}